import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import axios from "axios";
import swal from "sweetalert";
import PopupMenu from "./PopupMenu";
import CloseIcon from "@mui/icons-material/Close";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import "./header.css";

const Header = ({ profileProp }) => {
    // Axios interceptors setup
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("user");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    const navigate = useNavigate();
    const location = useLocation();

    const currentProductRef = useRef(null);
    const isPlayingRef = useRef(false);

    // 1. STATE CỦA HEADER CHUNG
    const [profile, setProfile] = useState(profileProp);
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify")));
    const [setting, setSetting] = useState(JSON.parse(localStorage.getItem("setting")));
    const [isOpen, setIsOpen] = useState(false);
    const [menu, setMenu] = useState(null);
    const [time, setTime] = useState("");
    const [isLoading, setLoading] = useState(false);

    // 2. STATE VÀ LOGIC CHO POPUP AUTH (LOGIN / REGISTER)
    const [showLoginPopup, setShowLoginPopup] = useState(false);
    const [showRegisterPopup, setShowRegisterPopup] = useState(false);
    const [affiliate, setAffiliate] = useState(null);
    const [errLogin, setErrLogin] = useState(null);
    const [errReg, setErrReg] = useState(null);

    const [showPassword, setShowPassword] = useState(false);
    const [showRegPassword, setShowRegPassword] = useState(false);
    const [showRegPasswordConfirm, setShowRegPasswordConfirm] = useState(false);
    const [showRegPayPwd, setShowRegPayPwd] = useState(false);

    const { register: regLogin, handleSubmit: handleLoginSubmit, formState: { errors: errsLogin }, setError: setErrLg, reset: resetLogin } = useForm();
    const { register: regRegister, handleSubmit: handleRegisterSubmit, formState: { errors: errsReg }, setError: setErrRg, reset: resetRegister } = useForm();

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const refParam = urlParams.get("ref");
        if (refParam) {
            setAffiliate(refParam);
            setShowRegisterPopup(true);
        } else if (localStorage.getItem("affiliate")) {
            setAffiliate(localStorage.getItem("affiliate"));
        }
    }, []);

    const onSubmitLogin = async (data) => {
        const regex = /^[a-zA-Z0-9]+$/;
        if (data.username.length < 6) return setErrLg("username", { message: "Tối thiểu 6 kí tự" });
        if (!regex.test(data.username)) return setErrLg("username", { message: "Không chứa khoảng trắng/kí tự đặc biệt" });
        if (data.password.length < 6) return setErrLg("password", { message: "Tối thiểu 6 kí tự" });

        axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
            username: data.username.toLowerCase(),
            password: data.password
        }).then((res) => {
            swal("Thông báo", "Đăng nhập thành công", "success").then(() => {
                localStorage.removeItem("user");
                localStorage.setItem("user", res.data.data);
                window.location.reload();
            });
        }).catch((err) => setErrLogin(err.response?.data?.message || "Tài khoản hoặc mật khẩu không chính xác!"));
    };

    const onSubmitRegister = (data, e) => {
        e.preventDefault();
        const phoneNumberPattern = /^(0\d{9,10})$/;
        const regex = /^[a-zA-Z0-9]+$/;

        if (data.username.length < 6) return setErrRg("username", { message: "Tối thiểu 6 kí tự" });
        if (data.username.length > 12) return setErrRg("username", { message: "Tối đa 12 kí tự" });
        if (!regex.test(data.username)) return setErrRg("username", { message: "Không hợp lệ" });
        if (data.password.length < 6) return setErrRg("password", { message: "Tối thiểu 6 kí tự" });
        if (data.password !== data.ippassword) return setErrRg("ippassword", { message: "Mật khẩu không khớp" });
        if (!data.sdt || !phoneNumberPattern.test(data.sdt)) return setErrRg("sdt", { message: "SĐT không hợp lệ" });
        if (data.paypwd.length < 6) return setErrRg("paypwd", { message: "Tối thiểu 6 kí tự" });

        const formData = {
            username: data.username.toLowerCase(),
            password: data.password,
            code: affiliate || (data.code === "" ? "admin" : data.code),
            sdt: data.sdt,
            name: data.username,
            paypwd: data.paypwd
        };

        axios.post(`${process.env.REACT_APP_API_URL}/auth/register`, formData)
            .then(() => {
                swal("Thông báo", "Đăng ký thành công", "success").then(() => {
                    axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, {
                        username: data.username.toLowerCase(),
                        password: data.password
                    }).then((res) => {
                        localStorage.setItem("user", res.data.data);
                        window.location.reload();
                    });
                });
            })
            .catch((err) => setErrReg(err.response?.data?.message || "Đã có lỗi xảy ra!"));
    };

    // 3. LOGIC TỰ ĐỘNG CHUYỂN QUỸ VÀ IFRAME GAME
    const [playGame, setPlayGame] = useState(null);
    const [product, setProduct] = useState(null);
    const [gameList, setGameList] = useState([]);
    const [showGameList, setShowGameList] = useState(false);
    const [listTitle, setListTitle] = useState("");
    const [searchQuery, setSearchQuery] = useState("");

    useEffect(() => { isPlayingRef.current = !!playGame; }, [playGame]);
    useEffect(() => { currentProductRef.current = product; }, [product]);

    const backgroundWithdraw = async (prodType) => {
        if (!prodType) return;
        try {
            const resBal = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: prodType });
            const currentBal = resBal.data?.data?.balance;
            if (currentBal >= 1) {
                await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                    product_type: prodType, type: 2, money: Math.floor(currentBal)
                });
                const resProfile = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
                setProfile(resProfile.data.data);
                localStorage.setItem("profile", JSON.stringify(resProfile.data.data));
            }
        } catch (e) {
            console.log("Rút tiền sảnh thất bại!", e);
        }
    };

    const handleForceExit = () => {
        if (isPlayingRef.current && currentProductRef.current) {
            const prodToWithdraw = currentProductRef.current;
            setPlayGame(null);
            setProduct(null);
            isPlayingRef.current = false;
            currentProductRef.current = null;
            document.body.classList.remove("header-game-playing");
            backgroundWithdraw(prodToWithdraw);
        }
    };

    useEffect(() => {
        const handleTabClose = () => {
            if (isPlayingRef.current && currentProductRef.current) {
                const token = localStorage.getItem("user");
                if (token) {
                    const prod = currentProductRef.current;
                    fetch(`${process.env.REACT_APP_API_URL}/casino/getbalance`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                        body: JSON.stringify({ product_type: prod }),
                        keepalive: true
                    }).then(res => res.json()).then(data => {
                        const bal = data?.data?.balance;
                        if (bal >= 1000) {
                            fetch(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                                body: JSON.stringify({ product_type: prod, type: 2, money: Math.floor(bal) }),
                                keepalive: true
                            }).catch(() => {});
                        }
                    }).catch(() => {});
                }
            }
        };
        window.addEventListener("beforeunload", handleTabClose);
        return () => window.removeEventListener("beforeunload", handleTabClose);
    }, []);

    useEffect(() => {
        handleForceExit();
    }, [location.pathname]);

    useEffect(() => {
        const interval = setInterval(() => {
            const now = new Date();
            setTime(now.toLocaleTimeString("vi-VN") + " " + now.toLocaleDateString("vi-VN"));
        }, 1000);

        if (localStorage.getItem("setting")) {
            setSetting(JSON.parse(localStorage.getItem("setting")));
        } else {
            axios.get(`${process.env.REACT_APP_API_URL}/setting/get`, {}).then((res) => setSetting(res.data.data[0]));
        }

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {}).then((res) => setNotify(res.data.data));

        const fetchProfileContinuous = () => {
            const token = localStorage.getItem("user");
            if (token) {
                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
                    .then((res) => {
                        setProfile(res.data.data);
                        localStorage.setItem("profile", JSON.stringify(res.data.data));
                    }).catch(() => {});
            }
        };

        fetchProfileContinuous();
        const timer = setInterval(fetchProfileContinuous, 3000);

        return () => {
            clearInterval(interval);
            clearInterval(timer);
        };
    }, []);

    useEffect(() => { if(profileProp) setProfile(profileProp); }, [profileProp]);

    useEffect(() => {
        if (playGame) {
            document.body.classList.add("header-game-playing");
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            document.body.classList.remove("header-game-playing");
        }
        return () => {
            document.body.classList.remove("header-game-playing");
        }
    }, [playGame]);

    function isMobileDevice() {
        if (window.innerWidth < 800) return true;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    const fetchGameList = (title, product_type, game_type) => {
        setListTitle(title); setSearchQuery(""); setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, { product_type, game_type })
            .then((res) => {
                if (res.data.data.length === 0) { swal("Thông báo", "Sảnh game bảo trì", "error"); setLoading(false); } 
                else { setGameList(res.data.data[0]); setShowGameList(true); setLoading(false); }
            }).catch(() => { swal("Thông báo", "Sảnh game bảo trì", "error"); setLoading(false); });
    };

    const launchGame = async (params) => {
        if (!localStorage.getItem("profile") || localStorage.getItem("profile") === "undefined") {
            setShowLoginPopup(true); return;
        }
        if (isLoading) return;
        
        handleForceExit();
        setLoading(true);

        try {
            const form = { ...params, platform: isMobileDevice() ? "html5" : "html5-desktop" };
            const resGame = await axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form);
            
            if (resGame.data.data.status !== 0) {
                setLoading(false); swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error"); return;
            }

            const gameUrl = resGame.data.data.game_url;
            setProduct(params.product_type);
            currentProductRef.current = params.product_type;
            setShowGameList(false);

            if (profile && profile.money >= 1000) {
                try {
                    await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: params.product_type, type: 1, money: Math.floor(profile.money)
                    });
                } catch (transferErr) { console.log("Lỗi chuyển tiền vào:", transferErr); }
            }

            setPlayGame(gameUrl);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error"); return;
            }
            swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
        }
    };

    const logOut = () => {
        handleForceExit();
        localStorage.clear();
        var now = new Date();
        now.setTime(now.getTime());
        document.cookie = "jwt=;Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        window.location.href = "/";
    };

    const getProfile = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                if (profile !== res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            }).catch(() => localStorage.removeItem("user"));
    };

    const openPopup = (num) => { handleForceExit(); setMenu(num); setIsOpen(true); };
    const closePopup = () => setIsOpen(false);

    function handleImageError(e, productCode, tcgGameCode) {
        e.target.onerror = null;
        e.target.src = `https://images.21947392.com/TCG_GAME_ICONS/${productCode}/${tcgGameCode}.png`;
    }

    const menuData = [
        { id: "topnav-home", title: "TRANG CHỦ", to: "/home", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/home.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/home_hover.png" },
        { id: "topnav-sports", title: "THỂ THAO", to: "/sports", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/sports.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/sports_hover.png", subMenu: [{ title: "FB THỂ THAO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/sport/afb2.png", productType: "142", gameCode: "FB0001" }, { title: "SABA THỂ THAO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/sport/ibc.png", productType: "174", gameCode: "SB0001" }, { title: "SBO THỂ THAO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/sport/sbo.png", productType: "54", gameCode: "SBO041" }, { title: "CMD THỂ THAO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/sport/tf.png", productType: "104", gameCode: "CMD001" }] },
        { id: "topnav-casino", title: "SÒNG BÀI", to: "/casino", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/casino.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/casino_hover.png", subMenu: [{ title: "DG CASINO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/casino/dg99.png", productType: "27", gameCode: "DG0013" }, { title: "WM CASINO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/casino/wm.png", productType: "118", gameCode: "WM0001" }, { title: "SEXY CASINO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/casino/sexy.png", productType: "112", gameCode: "SEX001" }, { title: "AG CASINO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/casino/ag.png", productType: "4", gameCode: "A00070" }, { title: "SA CASINO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/casino/sa.png", productType: "28", gameCode: "SA0001" }, { title: "EVO CASINO", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/casino/evo.png", productType: "86", gameCode: "EG0001" }] },
        { id: "topnav-slots", title: "SLOTS", to: "/slots", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/slots.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/slots_hover.png", subMenu: [{ title: "CQ9 SLOTS", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/slot/afb.png", productType: "16", gameType: "RNG" }, { title: "PPLAY SLOTS", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/slot/pplay.png", productType: "39", gameType: "RNG" }, { title: "JILI SLOTS", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/slot/hb.png", productType: "140", gameType: "RNG" }, { title: "JDB SLOTS", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/slot/playstar.png", productType: "55", gameType: "RNG" }, { title: "AG SLOTS", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/slot/play8.png", productType: "4", gameType: "RNG" }, { title: "BBIN SLOTS", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/slot/rtg.png", productType: "79", gameType: "RNG" }, { title: "MG SLOTS", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/slot/fc.png", productType: "43", gameType: "RNG" }, { title: "PG SLOTS", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/slot/pg.png", productType: "98", gameType: "RNG" }] },
        { id: "topnav-lottery", title: "XỔ SỐ", to: "/lottery", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/lottery.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/lottery_hover.png", subMenu: [{ title: "XS MIỀN BẮC", img: "https://i.ibb.co/nsy18NNG/image.png", navigateTo: "/lottery" }, { title: "XS MIỀN NAM", img: "https://i.ibb.co/7dLnZkGf/image.png", navigateTo: "/lottery" }, { title: "XS MIỀN TRUNG", img: "https://i.ibb.co/6RVv1zVz/image.png", navigateTo: "/lottery" }, { title: "XS NHANH 75S", img: "https://i.ibb.co/xSnPQpmS/image.png", navigateTo: "/lottery" }, { title: "XS NHANH 120S", img: "https://i.ibb.co/SDjGHMrh/image.png", navigateTo: "/lottery" }] },
        { id: "topnav-number", title: "TRÒ CHƠI", to: "/sicbo", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/icon-number.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/icon-number-hover.png", subMenu: [{ title: "TÀI XỈU 45S", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/number/auto_numbers.png", navigateTo: "/sicbo" }, { title: "TÀI XỈU 60S", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/number/live_numbers.png", navigateTo: "/sicbo" }, { title: "XÓC ĐĨA 45S", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/number/keno.png", navigateTo: "/sicbo" }, { title: "XÓC ĐĨA 60S", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/number/keno_new.png", navigateTo: "/sicbo" }] },
        { id: "topnav-poker", title: "GAME BÀI", to: "/pvp", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/poker.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/poker_hover.png", subMenu: [{ title: "V8 POKER", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/poker/ongdo.png", productType: "102", gameCode: "LCC001" }, { title: "KINGMAKER", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/poker/poke.png", productType: "121", gameCode: "KM0001" }, { title: "KING POKER", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/poker/kate.png", productType: "123", gameCode: "KP0001" }] },
        { id: "topnav-fish", title: "BẮN CÁ", to: "/fishing", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/fish.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/fish_hover.png", subMenu: [{ title: "JILI BẮN CÁ", img: "https://i.ibb.co/m5xwQ38z/image.png", productType: "140", gameType: "FISH" }, { title: "MG BẮN CÁ", img: "https://i.ibb.co/mVqvWFsx/image.png", productType: "43", gameType: "FISH" }, { title: "CQ9 BẮN CÁ", img: "https://i.ibb.co/bjs9b3rs/image.png", productType: "16", gameType: "FISH" }, { title: "JDB BẮN CÁ", img: "https://i.ibb.co/mrDD5tVD/image.png", productType: "55", gameType: "FISH" }] },
        { id: "topnav-cockfight", title: "ĐÁ GÀ", to: "/cockfighting", icon: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/cock.png", iconHover: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/cock_hover.png", subMenu: [{ title: "ĐÁ GÀ WS168", img: "https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/nav/cockfight/cf361.png", productType: "202", gameCode: "WS1682" }, { title: "ĐÁ GÀ SV388", img: "https://i.ibb.co/FCGMZYk/image.png", productType: "132", gameCode: "SV3002" }] }
    ];

    return (
        <>
            {isLoading && (
                <div className="loading" style={{ zIndex: 99999999 }}>
                    <div className="loader"></div>
                </div>
            )}

            <style>{`
                body.header-game-playing .main,
                body.header-game-playing .bg-esport,
                body.header-game-playing .sports-wrapper,
                body.header-game-playing .bg-fishing,
                body.header-game-playing .slot-page-wrapper,
                body.header-game-playing .pvp-page-wrapper,
                body.header-game-playing .content_lobby,
                body.header-game-playing .banner,
                body.header-game-playing footer { display: none !important; }

                .global-popup-overlay {
                    position: fixed !important; top: 0 !important; left: 0 !important; width: 100vw !important; height: 100vh !important; background: rgba(0, 0, 0, 0.75) !important; z-index: 9999999 !important; display: flex !important; align-items: center !important; justify-content: center !important; padding: 15px; box-sizing: border-box;
                }

                @keyframes popInCenter { 0% { opacity: 0; transform: scale(0.8); } 100% { opacity: 1; transform: scale(1); } }
                @keyframes fadeInDown { 0% { opacity: 0; transform: translateY(-10px); } 100% { opacity: 1; transform: translateY(0); } }

                /* ============================================================ */
                /* STYLE ĐĂNG NHẬP (DROPDOWN DƯỚI HEADER) */
                /* ============================================================ */
                .invisible-overlay { position: fixed; inset: 0; z-index: 9999998; cursor: default; }

                .login-dropdown-box {
                    position: absolute;
                    top: calc(100% + 15px); /* Khoảng cách từ nút xuống box */
                    right: 0;
                    width: 320px;
                    background: #f0f2f5;
                    border-radius: 8px;
                    box-shadow: 0 5px 20px rgba(0,0,0,0.4);
                    z-index: 9999999;
                    animation: fadeInDown 0.2s ease-out forwards;
                    cursor: default;
                }
                
                /* Mũi tên tam giác chĩa lên */
                .login-dropdown-box::before {
                    content: ''; position: absolute; top: -8px; right: 25px;
                    border-left: 8px solid transparent; border-right: 8px solid transparent;
                    border-bottom: 8px solid #f0f2f5;
                }

                .login-close-btn { position: absolute; right: 20px; top: 8px; cursor: pointer; color: #555; line-height: 0; transition: 0.2s; }
                .login-close-btn:hover { color: #d32f2f; }
                .login-popup-header { text-align: center; padding: 25px 20px 15px; }
                .login-popup-header h2 { margin: 0; font-size: 20px; font-weight: bold; color: #333; }
                .login-popup-body { padding: 0 25px 25px; }
                
                .login-input-group {
                    display: flex; align-items: center;
                    background: #dcdcdc; border-radius: 4px; height: 42px; margin-bottom: 15px;
                    position: relative; border: 1px solid transparent;
                }
                .login-input-group:focus-within { border: 1px solid #aaa; background: #fff;}
                .login-icon-left { width: 45px; text-align: center; color: #555; font-size: 16px; }
                .login-input-group input {
                    flex: 1; height: 100%; border: none; background: transparent;
                    font-size: 14px; color: #333; outline: none; padding-right: 35px;
                }
                .btn-login-submit {
                    width: 100%; background: #e02e2e; color: #fff; border: none;
                    border-radius: 4px; padding: 12px; font-size: 15px; font-weight: bold;
                    cursor: pointer; transition: 0.3s; margin-top: 5px;
                }
                .btn-login-submit:hover { background: #b71c1c; }
                .login-switch-link { text-align: center; margin-top: 15px; font-size: 12px; color: #888; }
                .login-switch-link span { color: #d32f2f; cursor: pointer; }
                .login-switch-link span:hover { text-decoration: underline; }

                /* Ép Icon con mắt ở Login vào chính giữa trục Y */
                .login-icon-right { position: absolute; right: 24px; top: 31%; transform: translateY(-50%); color: #555; cursor: pointer; line-height: 0; }

                /* ============================================================ */
                /* STYLE ĐĂNG KÝ (MODAL Ở GIỮA, KÍNH MỜ, VIÊN THUỐC) */
                /* ============================================================ */
                .register-popup-box {
                    background: url('https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/register_bg.png') no-repeat center center;
                    background-size: cover;
                    background-color: rgba(220, 235, 245, 0.9);
                    backdrop-filter: blur(8px);
                    -webkit-backdrop-filter: blur(8px);
                    width: 100%; max-width: 800px;
                    border-radius: 20px;
                    position: relative; padding: 25px 40px 30px;
                    box-shadow: 0 10px 40px rgba(0,0,0,0.4);
                    animation: popInCenter 0.3s ease-out forwards;
                    max-height: 95vh; overflow-y: auto;
                    border: 1px solid rgba(255, 255, 255, 0.4);
                }

                .reg-close-btn { position: absolute; right: 30px; top: 15px; cursor: pointer; color: #555; line-height: 0; transition: 0.2s; }
                .reg-close-btn:hover { color: #d32f2f; }

                .reg-header { text-align: center; margin-bottom: 20px; }
                .reg-logo-img { height: 60px; object-fit: contain; margin-bottom: 10px; }
                .reg-title { margin: 0; font-size: 22px; font-weight: bold; color: #333; }

                .reg-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px 30px; }

                .reg-input-wrap label { display: block; font-size: 13px; color: #3870a3; font-weight: bold; margin-bottom: 6px; }
                .reg-input-wrap label i { color: #f24a4a; margin-right: 5px; font-size: 11px; }

                .reg-input-inner {
                    position: relative; display: flex; align-items: center;
                    background: rgba(255, 255, 255, 0.6); 
                    border-radius: 30px;
                    height: 42px;
                    border: 1px solid rgba(255,255,255,0.6);
                    box-sizing: border-box;
                }
                
                .reg-input-inner input {
                    flex: 1; height: 100%; border: none; background: transparent;
                    font-size: 13px; color: #333; outline: none; padding: 0 20px;
                }
                .reg-input-inner input::placeholder { color: #87a1ba; }
                .reg-input-inner input:read-only { background: rgba(200, 215, 230, 0.4); border-radius: 30px; }

                /* Ép Icon con mắt ở Đăng Ký vào chính giữa trục Y */
                .auth-icon-right { position: absolute; right: 26px; top: 30%; transform: translateY(-50%); color: #3870a3; cursor: pointer; line-height: 0; }

                .auth-error-msg { color: #d32f2f; font-size: 11px; margin-top: 5px; padding-left: 15px; font-style: italic; }

                .reg-terms { grid-column: 1 / -1; display: flex; align-items: center; gap: 8px; font-size: 13px; color: #333; margin-top: 10px; padding-left: 5px;}
                .reg-terms a { color: #d32f2f; text-decoration: underline; }

                .reg-btn-wrapper { grid-column: 1 / -1; text-align: center; margin-top: 10px; }
                .btn-reg-submit {
                    background: #e33b54; 
                    color: #fff; border: none; border-radius: 30px; padding: 12px 40px;
                    font-size: 16px; font-weight: bold; cursor: pointer;
                    box-shadow: 0 4px 15px rgba(227, 59, 84, 0.4); transition: 0.3s;
                    text-transform: uppercase; min-width: 200px;
                }
                .btn-reg-submit:hover { background: #c22941; transform: translateY(-2px); box-shadow: 0 6px 15px rgba(227, 59, 84, 0.6);}

                .auth-switch-link span { color: #d32f2f; cursor: pointer; transition: 0.3s;}
                .auth-switch-link span:hover { text-decoration: underline; }

                @media (max-width: 768px) { .reg-grid { grid-template-columns: 1fr; gap: 15px; } .register-popup-box { padding: 20px; } }

                /* DANH SÁCH GAME CON */
                .premium-popup { position: relative; background: #ffffff; border-radius: 16px; width: 100%; max-width: 450px; box-shadow: 0 10px 40px rgba(0,0,0,0.6); animation: popInCenter 0.3s ease-out forwards; display: flex; flex-direction: column; max-height: 95vh; }
                .premium-popup-header { background: linear-gradient(135deg, #d32f2f, #b71c1c); color: #fff; padding: 15px 50px 15px 20px; font-size: 20px; font-weight: bold; text-align: left; position: relative; box-sizing: border-box; width: 100%; border-radius: 16px 16px 0 0; }
                .premium-close-btn { position: absolute !important; right: 30px !important; top: 20% !important; transform: translateY(-50%) !important; cursor: pointer; display: flex; align-items: center; justify-content: center; z-index: 10; }
                .gamelist-popup { max-width: 1000px !important; height: 85vh; }
                .gamelist-popup-body { padding: 20px; flex-grow: 1; overflow-y: auto; background: #0d121c; border-radius: 0 0 16px 16px; }
                .gl-search-box { position: relative; width: 100%; margin-bottom: 20px; }
                .gl-search-box input { width: 100%; padding: 12px 15px 12px 40px; border-radius: 20px; border: none; background: #2b3245; color: #fff; outline: none; font-size: 16px; }
                .gl-search-icon { position: absolute; left: 15px; top: 50%; transform: translateY(-50%); color: #8fa0c0; }
                .new-grid-6 { display: grid; grid-template-columns: repeat(6, 1fr); gap: 15px; }
                @media (max-width: 1000px) { .new-grid-6 { grid-template-columns: repeat(4, 1fr); } }
                @media (max-width: 600px) { .new-grid-6 { grid-template-columns: repeat(3, 1fr); } }
                .new-gameslot-item { background: #2b3245; border-radius: 10px; overflow: hidden; cursor: pointer; transition: transform 0.2s; }
                .new-gameslot-item:hover { transform: translateY(-3px); box-shadow: 0 5px 15px rgba(0,0,0,0.5); }
                .new-gameslot-item img { width: 100%; height: auto; aspect-ratio: 1/1; object-fit: cover; display: block; }
                .new-gameslot-name { background: #1e2433; color: #fff; text-align: center; padding: 10px 5px; font-size: 13px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

                /* IFRAME GAME */
                .embedded-game-container { width: 100%; height: calc(100vh - 105px); min-height: 700px; display: flex; flex-direction: column; background: #000; margin: 0; padding: 0; }
                .embedded-game-header { height: 45px; background: #1a1a1a; display: flex; align-items: center; justify-content: flex-start; padding: 0 15px; border-bottom: 2px solid #b71c1c; }
                .btn-exit-game { display: flex; align-items: center; background: #d32f2f; color: #fff; border: none; padding: 6px 15px; border-radius: 4px; cursor: pointer; font-weight: bold; font-size: 14px; text-transform: uppercase; transition: 0.2s; }
                .btn-exit-game:active { background: #b71c1c; transform: scale(0.98); }
                .btn-exit-game span { margin-left: 5px; }
                .game-iframe { width: 100%; flex: 1; border: none; background: #000; }
            `}</style>

            <header id="header">
                {/* --- HEADER TOP --- */}
                <div className="header-top">
                    <div className="container" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        
                        <div className="topbar-left" style={{ display: "flex", alignItems: "center" }}>
                            <a className="lang-items lang-active" href="/vn" onClick={handleForceExit}>
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/vn.png" alt="Vietnam" />
                            </a>
                            <span id="clock" className="current-time" style={{ marginLeft: "10px", marginRight: "35px" }}>
                                {time}
                            </span>
                            
                            {profile && (
                                <div className="after-login" style={{ display: "flex", alignItems: "center" }}>
                                    <div className="top-dropdown user-dropdown">
                                        <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/member.png" alt="Member" />
                                        <span className="wallet-text">
                                            {profile.username || "Tài khoản"} <i className="fa fa-chevron-down"></i>
                                        </span>
                                        <ul className="top-menu user-setting-menu">
                                            <li onClick={() => { handleForceExit(); openPopup(1); }}><a href="#!">Cá Nhân</a></li>
                                            <li><a href="/vn/change_password" onClick={handleForceExit}>Đổi Mật Khẩu</a></li>
                                        </ul>
                                    </div>
                                    <div className="top-dropdown balance-dropdown">
                                        <img className="balance-img" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/balance.png" alt="Balance" />
                                        <img className="balance-img-hover" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/balance_hover.png" alt="Balance Hover" />
                                        <div className="wallet-text">
                                            Số dư: <span className="wmain">{Math.floor(profile.money / 1000).toLocaleString("vi-VN")}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="topbar-right">
                            {profile ? (
                                <div className="member-btn after-login" style={{ display: "flex", gap: "5px" }}>
                                    <a className="register-btn btn" onClick={() => { handleForceExit(); openPopup(2); }} href="#!"><i className="fa fa-money"></i>Nạp tiền</a>
                                    <a className="register-btn btn" onClick={() => { handleForceExit(); openPopup(3); }} href="#!"><i className="fa fa-usd"></i>Rút tiền</a>
                                    <a className="register-btn btn" onClick={() => { handleForceExit(); openPopup(7); }} href="#!"><i className="fa fa-location-arrow"></i>Chuyển đổi</a>
                                    <a className="register-btn btn" onClick={() => { handleForceExit(); openPopup(4); }} href="#!"><i className="fa fa-history"></i> Lịch sử</a>
                                    <a className="register-btn btn" onClick={logOut} href="#!"><i className="fa fa-sign-out"></i>Đăng xuất</a>
                                </div>
                            ) : (
                                <div className="member-btn" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    
                                    {/* KHỐI ĐĂNG NHẬP VỚI MENU DROPDOWN */}
                                    <div className="login-wrapper" style={{ cursor: "pointer", position: "relative" }}>
                                        <div className="login-btn btn" style={{ textDecoration: 'none' }} onClick={() => { handleForceExit(); setShowLoginPopup(!showLoginPopup); setShowRegisterPopup(false); }}>
                                            <svg width="100" height="35" xmlns="http://www.w3.org/2000/svg">
                                                <defs>
                                                    <linearGradient id="grad1">
                                                        <stop offset="0%" stopColor="#ffffa7"></stop>
                                                        <stop offset="20%" stopColor="#efc544"></stop>
                                                        <stop offset="50%" stopColor="#ffffa7"></stop>
                                                        <stop offset="74%" stopColor="#f1cc50"></stop>
                                                        <stop offset="100%" stopColor="#ffffa7"></stop>
                                                    </linearGradient>
                                                </defs>
                                                <rect x="0" y="0" rx="4" fill="none" stroke="url(#grad1)" width="110" height="40"></rect>
                                            </svg>
                                            <span><i className="fa fa-sign-in"></i>Đăng nhập</span>
                                        </div>

                                        {showLoginPopup && (
                                            <>
                                                {/* Lớp nền trong suốt bắt sự kiện click ra ngoài để đóng hộp đăng nhập */}
                                                <div className="invisible-overlay" onClick={(e) => { e.stopPropagation(); setShowLoginPopup(false); }}></div>
                                                
                                                {/* BOX DROPDOWN ĐĂNG NHẬP (ẢNH 3) */}
                                                <div className="login-dropdown-box" onClick={(e) => e.stopPropagation()}>
                                                    <div className="login-close-btn" onClick={() => setShowLoginPopup(false)}>
                                                        <CloseIcon sx={{ fontSize: "18px" }} />
                                                    </div>
                                                    <div className="login-popup-header">
                                                        <h2>Đăng nhập</h2>
                                                    </div>
                                                    <div className="login-popup-body">
                                                        <form onSubmit={handleLoginSubmit(onSubmitLogin)}>
                                                            {errLogin && <p style={{ color: 'red', textAlign: 'center', fontSize: '14px', marginBottom: '10px' }}>{errLogin}</p>}
                                                            
                                                            <div className="login-input-group">
                                                                <div className="login-icon-left"><i className="fa fa-user"></i></div>
                                                                <input type="text" {...regLogin("username")} placeholder="Tài khoản" />
                                                            </div>
                                                            {errsLogin.username && <p className="auth-error-msg">{errsLogin.username.message}</p>}

                                                            <div className="login-input-group">
                                                                <div className="login-icon-left"><i className="fa fa-key"></i></div>
                                                                <input type={showPassword ? "text" : "password"} {...regLogin("password")} placeholder="Mật khẩu" />
                                                                <div className="login-icon-right" onClick={() => setShowPassword(!showPassword)}>
                                                                    {showPassword ? <Visibility sx={{ fontSize: "20px" }} /> : <VisibilityOff sx={{ fontSize: "20px" }} />}
                                                                </div>
                                                            </div>
                                                            {errsLogin.password && <p className="auth-error-msg">{errsLogin.password.message}</p>}

                                                            <button type="submit" className="btn-login-submit">Đăng nhập</button>

                                                            <div className="login-switch-link">
                                                                Không có tài khoản ? <span onClick={() => { setShowLoginPopup(false); setShowRegisterPopup(true); resetLogin(); setErrLogin(null); }}>Đăng ký</span>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {/* NÚT ĐĂNG KÝ */}
                                    <div onClick={() => { handleForceExit(); setShowRegisterPopup(true); setShowLoginPopup(false); }} className="login-btn btn" style={{ cursor: "pointer" }}>
                                        <i className="fa fa-edit"></i>Đăng ký
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* --- HEADER BOTTOM --- */}
                <div className="header-bottom">
                    <div className="container" style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: "40px" }}>
                        <div className="topbar-left" style={{ flexShrink: 0 }}>
                            <Link to="/" onClick={handleForceExit}>
                                <img src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/logo.png" alt="Logo" style={{ display: "block", height: "70px", width: "auto", objectFit: "contain" }} />
                            </Link>
                        </div>
                        <div className="topbar-right" style={{ flexGrow: 1 }}>
                            <nav className="navbars">
                                <ul className="navbar-list" style={{ display: "flex", gap: "15px", alignItems: "center", margin: 0 }}>
                                    {menuData.map((item, index) => (
                                        <li key={index} id={item.id} className={location.pathname === item.to ? "active" : ""}>
                                            <Link to={item.to} onClick={handleForceExit}>
                                                <img className="orig-img" src={item.icon} alt={item.title} />
                                                <img className="hover-img" src={item.iconHover} alt={item.title} />
                                                <span>{item.title}</span>
                                            </Link>
                                            {item.subMenu && (
                                                <div className="sub-navbar">
                                                    <ul className="sub-navbar-list container justify-content-start" style={{ padding: "0 10px" }}>
                                                        {item.subMenu.map((sub, idx) => (
                                                            <li key={idx}>
                                                                <a href="#!" className="sub-navbar-items p_login" onClick={(e) => {
                                                                    e.preventDefault(); handleForceExit();
                                                                    if (sub.gameType) fetchGameList(sub.title, sub.productType, sub.gameType);
                                                                    else if (sub.productType && sub.gameCode) launchGame({ product_type: sub.productType, game_code: sub.gameCode });
                                                                    else if (sub.navigateTo) navigate(sub.navigateTo);
                                                                }}>
                                                                    <img src={sub.img} alt={sub.title} style={{ width: "100px", objectFit: "contain" }} />
                                                                    <span>{sub.title}</span>
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                    <li id="topnav-promotions">
                                        <Link to="/promotion" className="hot" onClick={handleForceExit}>
                                            <img className="orig-img" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/promotion.png" alt="Promo" />
                                            <img className="hover-img" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/icon/promotion_hover.png" alt="Promo Hover" />
                                            <span>KHUYẾN MÃI</span>
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </header>

            {/* KHUNG IFRAME GAME HIỂN THỊ NẰM GỌN GÀNG DƯỚI HEADER */}
            {playGame && (
                <div className="embedded-game-container">
                    <div className="embedded-game-header">
                        <button className="btn-exit-game" onClick={handleForceExit}>
                            <KeyboardArrowLeftOutlinedIcon style={{ fontSize: "20px" }}/>
                            <span>THOÁT GAME</span>
                        </button>
                    </div>
                    <iframe src={playGame} className="game-iframe" title="In-Web Game" allowFullScreen />
                </div>
            )}

            {/* ======================================================= */}
            {/* POPUP ĐĂNG KÝ (STYLE ẢNH 1 & 2 - BO TRÒN KÍNH MỜ) */}
            {/* ======================================================= */}
            {showRegisterPopup && (
                <div className="global-popup-overlay" onClick={(e) => { if(e.target === e.currentTarget) setShowRegisterPopup(false); }}>
                    <div className="register-popup-box">
                        <div className="reg-close-btn" onClick={() => setShowRegisterPopup(false)}>
                            <CloseIcon sx={{ fontSize: "16px" }} />
                        </div>
                        
                        <div className="reg-header">
                            <img className="reg-logo-img" src="https://d2ajue4o5x1lc3.cloudfront.net/content/sandsvn/images/logo.png" alt="Logo" />
                            <h2 className="reg-title">Đăng ký ngay</h2>
                        </div>

                        <form onSubmit={handleRegisterSubmit(onSubmitRegister)}>
                            {errReg && <p style={{ color: 'red', textAlign: 'center', fontSize: '14px', marginBottom: '15px' }}>{errReg}</p>}
                            
                            <div className="reg-grid">
                                <div className="reg-col">
                                    <div className="reg-input-wrap">
                                        <label><i className="fa fa-star"></i> Tên tài khoản</label>
                                        <div className="reg-input-inner">
                                            <input type="text" {...regRegister("username")} placeholder="Tên tài khoản từ 6-20 Kí Tự..." />
                                        </div>
                                        {errsReg.username && <p className="auth-error-msg" style={{marginTop: "5px"}}>{errsReg.username.message}</p>}
                                    </div>

                                    <div className="reg-input-wrap" style={{marginTop: "15px"}}>
                                        <label><i className="fa fa-star"></i> Xác nhận mật khẩu</label>
                                        <div className="reg-input-inner">
                                            <input type={showRegPasswordConfirm ? "text" : "password"} {...regRegister("ippassword")} placeholder="Phần xác nhận mật khẩu không để trống" />
                                            <div className="auth-icon-right" onClick={() => setShowRegPasswordConfirm(!showRegPasswordConfirm)}>
                                                {showRegPasswordConfirm ? <Visibility sx={{ fontSize: "20px" }} /> : <VisibilityOff sx={{ fontSize: "20px" }} />}
                                            </div>
                                        </div>
                                        {errsReg.ippassword && <p className="auth-error-msg" style={{marginTop: "5px"}}>{errsReg.ippassword.message}</p>}
                                    </div>

                                    <div className="reg-input-wrap" style={{marginTop: "15px"}}>
                                        <label><i className="fa fa-star"></i> Số điện thoại</label>
                                        <div className="reg-input-inner">
                                            <input type="tel" {...regRegister("sdt")} placeholder="Nhập số điện thoại hợp lệ" />
                                        </div>
                                        {errsReg.sdt && <p className="auth-error-msg" style={{marginTop: "5px"}}>{errsReg.sdt.message}</p>}
                                    </div>
                                </div>

                                <div className="reg-col">
                                    <div className="reg-input-wrap">
                                        <label><i className="fa fa-star"></i> Mật khẩu</label>
                                        <div className="reg-input-inner">
                                            <input type={showRegPassword ? "text" : "password"} {...regRegister("password")} placeholder="Mật khẩu cần hơn 8 ký tự bao gồm chữ và số" />
                                            <div className="auth-icon-right" onClick={() => setShowRegPassword(!showRegPassword)}>
                                                {showRegPassword ? <Visibility sx={{ fontSize: "20px" }} /> : <VisibilityOff sx={{ fontSize: "20px" }} />}
                                            </div>
                                        </div>
                                        {errsReg.password && <p className="auth-error-msg" style={{marginTop: "5px"}}>{errsReg.password.message}</p>}
                                    </div>

                                    <div className="reg-input-wrap" style={{marginTop: "15px"}}>
                                        <label><i className="fa fa-star"></i> Mật khẩu rút tiền</label>
                                        <div className="reg-input-inner">
                                            <input type={showRegPayPwd ? "text" : "password"} {...regRegister("paypwd")} placeholder="Tối thiểu 6 ký tự" />
                                            <div className="auth-icon-right" onClick={() => setShowRegPayPwd(!showRegPayPwd)}>
                                                {showRegPayPwd ? <Visibility sx={{ fontSize: "20px" }} /> : <VisibilityOff sx={{ fontSize: "20px" }} />}
                                            </div>
                                        </div>
                                        {errsReg.paypwd && <p className="auth-error-msg" style={{marginTop: "5px"}}>{errsReg.paypwd.message}</p>}
                                    </div>

                                    <div className="reg-input-wrap" style={{marginTop: "15px"}}>
                                        <label><i className="fa fa-star"></i> Mã giới thiệu</label>
                                        <div className="reg-input-inner">
                                            <input type="text" {...regRegister("code")} placeholder="Mã mời (Nếu có)" defaultValue={affiliate || ""} readOnly={!!affiliate} />
                                        </div>
                                    </div>
                                </div>

                                <div className="reg-terms">
                                    <input type="checkbox" id="agree_terms" required defaultChecked />
                                    <label htmlFor="agree_terms" style={{margin: 0, fontWeight: "normal", color: "#333", fontSize: "13px"}}>
                                        Đã đủ 18 tuổi và đồng ý với trang web này <a href="#!">Thỏa thuận đăng ký người dùng</a>
                                    </label>
                                </div>

                                <div className="reg-btn-wrapper">
                                    <button type="submit" className="btn-reg-submit">ĐĂNG KÝ</button>
                                </div>
                            </div>
                        </form>
                        
                        <div className="auth-switch-link" style={{textAlign: "center", marginTop: "15px", fontSize: "14px", color: "#333"}}>
                            Đã có tài khoản ? <span onClick={() => { setShowRegisterPopup(false); setShowLoginPopup(true); resetRegister(); setErrReg(null); }}>Đăng nhập ngay</span>
                        </div>
                    </div>
                </div>
            )}

            {/* POPUP CHỌN GAME CON */}
            {showGameList && gameList ? (
                <div className="global-popup-overlay" onClick={(e) => { if(e.target === e.currentTarget) setShowGameList(false); }}>
                    <div className="premium-popup gamelist-popup">
                        <div className="premium-popup-header">
                            {listTitle}
                            <div className="premium-close-btn" onClick={() => setShowGameList(false)}>
                                <CloseIcon sx={{ fontSize: "28px", color: "#fff" }} />
                            </div>
                        </div>
                        <div className="gamelist-popup-body">
                            <div className="gl-search-box">
                                <i className="fa fa-search gl-search-icon"></i>
                                <input type="text" placeholder="Tìm kiếm game..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
                            </div>
                            <div className="new-grid-6">
                                {gameList.filter(item => item.gameName.toLowerCase().includes(searchQuery.toLowerCase())).length > 0 ? (
                                    gameList.filter(item => item.gameName.toLowerCase().includes(searchQuery.toLowerCase())).map((item, index) => (
                                        <div className="new-gameslot-item" key={index} onClick={() => launchGame({ product_type: item.productType, game_code: item.tcgGameCode })}>
                                            <img src={`https://images.21947392.com/TCG_GAME_ICONS/${item.productCode}/VI/${item.tcgGameCode}.png`} onError={(e) => handleImageError(e, item.productCode, item.tcgGameCode)} alt={item.gameName} />
                                            <div className="new-gameslot-name">{item.gameName}</div>
                                        </div>
                                    ))
                                ) : (
                                    <div style={{ color: '#fff', fontSize: '16px', gridColumn: '1 / -1', textAlign: 'center', padding: '50px 0' }}>Không tìm thấy game phù hợp!</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}

            <PopupMenu profile={profile} isOpen={isOpen} isClose={closePopup} menuActive={menu} getProfile={getProfile} />
        </>
    );
};

export default Header;